import { useQuery } from "@tanstack/react-query"
import API_END_POINT, { ROUTES } from "../api/apiEndpoints"
import { apiClient } from "../api/apiService"
import { TPropertyList } from "../types/TProperties"

type TProperties = {
  id?: number
  enabled?: boolean
}

const useProperties = (props?: TProperties) => {
  let localId = -1 // Default to Throw Error if Local Storage is somehow cleared ?
  try {
    localId = JSON.parse(localStorage?.getItem("userData") || "")?.["id"]
  } catch {}

  const { enabled = true, id = localId } = props ? props : {}
  return useQuery<TPropertyList>({
    queryKey: ["Properties"],
    queryFn: () => {
      return apiClient.post(API_END_POINT.POST[ROUTES.getProperty], {
        owner_id: id,
      })
    },
    enabled: enabled,
  })
}

export default useProperties
